import { ICliente } from 'app/types/ICliente';
import { atualizarClientePendente } from 'app/use-cases/orcamento/cliente/atualizarClientePendente';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import globalMU from "../../../../globalMU";
import microuniversoApi from "../../../api/microuniversoApi";
import { useAppSelector } from "../../../redux/hooks";
import { DomainDataPendenciaCliente } from "../../../types/cliente/DomainDataPendenciaCliente";
import { tratamentoErroPadrao } from "../../../use-cases";
import { renderizarComponentReact } from "../../renderizarOuRemoverComponentReact";
import { AbasPesquisaClienteContainer } from "../AbasPesquisaClienteContainer";
import { OrcamentoEmAbertoForm } from "./orcamentoEmAberto/OrcamentoEmAberto";
import { PendenciaCliente } from "./PendenciaCliente";

export type PendenciaClienteContainerProps = {
    domain: DomainDataPendenciaCliente;
    regiaoRenderizada: string;
    cliente: ICliente;
    onVoltar: () => void;
};

export const PendenciaClienteContainer = React.memo((props: PendenciaClienteContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);
    const [data, setData] = useState<DomainDataPendenciaCliente>(props.domain);
    const [senhaVendedorRelacionado, setSenhaVendedorRelacionado] = useState<string>('');
    const [senhaOrcamentoEmAberto, setSenhaOrcamentoEmAberto] = useState<string>('');
    const [senhaAreaDeVenda, setSenhaAreaDeVenda] = useState<string>('');
    const [senhaClienteComLimiteCreditoBloqueado, setSenhaClienteComLimiteCreditoBloqueado] = useState<string>('');
    const [processando, setProcessando] = useState(false);

    const filtrarOrcamentosEmAberto = useCallback(async (filtros: OrcamentoEmAbertoForm) => {
        try {
            globalMU.blockUI();
            const dados = await microuniversoApi.Cliente.filtrarOrcamentosEmAberto(filtros);
            setData(prevData => ({
                ...prevData,
                ExistemPedidosEmAbertoClienteException: {
                    ...prevData.ExistemPedidosEmAbertoClienteException,
                    Pedidos: dados
                }
            }));
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, []);

    const validarSenhas = useCallback(() => {
        if (props.domain?.ExistemPedidosEmAbertoClienteException?.ExigirSenha && !senhaOrcamentoEmAberto) {
            globalMU.showErrorMessage('O campo "Senha" da pendência "Orçamentos em Aberto" é obrigatório');
            return false;
        }
        if (props.domain?.VendedorRelacionadoClienteDiferenteVendedorLogadoException && !senhaVendedorRelacionado) {
            globalMU.showErrorMessage('O campo "Senha" da pendência "Vendedor relacionado" é obrigatório');
            return false;
        }
        if (props.domain?.ClienteComLimiteCreditoBloqueadoException && !senhaClienteComLimiteCreditoBloqueado) {
            globalMU.showErrorMessage('O campo "Senha" da pendência "Limite de Crédito para Clientes Bloqueados" é obrigatório');
            return false;
        }
        return true;
    }, [props.domain, senhaOrcamentoEmAberto, senhaVendedorRelacionado, senhaClienteComLimiteCreditoBloqueado]);

    const atualizarCliente = useCallback(async () => {
        
        try {
            setProcessando(true);
            globalMU.blockUI();
            if (!validarSenhas()) return;


            const retorno = await atualizarClientePendente(
                props.cliente,
                senhaOrcamentoEmAberto,
                senhaVendedorRelacionado,
                senhaClienteComLimiteCreditoBloqueado,
                false
            );

            let temErro = ("HasErrors" in retorno)
                && retorno.HasErrors
                && retorno.ErrorLevel !== "Warn";

            //if (!("HasErrors" in retorno)) {
            if (!temErro) {
                renderizarComponentReact(
                    <AbasPesquisaClienteContainer regiaoRenderizada={props.regiaoRenderizada} />,
                    props.regiaoRenderizada,
                    true
                );
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            setProcessando(false);
            globalMU.unblockUI();
        }
    }, [props.cliente, senhaOrcamentoEmAberto, senhaVendedorRelacionado, senhaClienteComLimiteCreditoBloqueado, props.regiaoRenderizada, validarSenhas]);

    useEffect(() => {
        setData(props.domain);
    }, [props.domain]);

    return (
        <PendenciaCliente
            onAlterarSenhaOrcamentoEmAberto={setSenhaOrcamentoEmAberto}
            valoresFormularioOrcamentoEmAberto={{
                CodigoCliente: props.cliente.Codigo,
                CodigoFilial: orcamento.CodigoFilialOrcamento,
                DataFinal: '',
                DataInicial: '',
                NumeroPagina: 1,
                TamanhoPagina: 5,
                Transforming: false,
                UserMessage: ''
            }}
            domain={data}
            processando={processando}
            onVoltar={props.onVoltar}
            onFiltrarOrcamentosEmAberto={filtrarOrcamentosEmAberto}
            onAlterarPaginaOrcamentosEmAberto={filtrarOrcamentosEmAberto}
            onAlterarSenhaVendedorRelacionado={setSenhaVendedorRelacionado}
            onAlterarSenhaAreaDeVenda={setSenhaAreaDeVenda}
            onAlterarsenhaClienteComLimiteCreditoBloqueado={setSenhaClienteComLimiteCreditoBloqueado}
            onOk={atualizarCliente}
        />
    );
});